module.exports = __webpack_public_path__ + "img/hand-ok.3b0a5b49.png";